import { createFileRoute, redirect } from "@tanstack/react-router"

import { BrandDemoPage } from "@/pages/dev/brand-demo"

export const Route = createFileRoute("/_authenticated/settings/dev/demos/brand")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: BrandDemoPage,
})
